<template>
  <file-pond
    name="image"
    label-idle="Drag & Drop your excel file or <span class='filepond--label-action'>Browse</span>"
    :allow-multiple="false"
    :accepted-file-types="['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', '.xlsx']"
    @updatefiles="handleFileUpdate"
  />
</template>

<script>
import vueFilePond from "vue-filepond";

import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";

import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";

const FilePond = vueFilePond(
  FilePondPluginImagePreview,
  FilePondPluginFileValidateType
);

export default {
  components: { FilePond },
  emit: ["file-result"],
  methods: {
    handleFileUpdate(fileItems) {
      const file = fileItems[0]?.file;
      if (file) {
        this.$emit("file-result", file);
      }
    },
  },
};
</script>
